import React, { useState, useEffect } from 'react';
import { auth, sendEmailVerification, signOut } from '../firebase';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ClipLoader } from 'react-spinners';
import logo from '../assets/logo.png';
import './VerifyEmail.css';

const VerifyEmail = () => {
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    let isMounted = true;

    const checkVerification = async () => {
      const user = auth.currentUser;
      if (!user) {
        if (isMounted) {
          setError('You must be logged in to verify your email.');
          toast.error('Please log in to verify your email.');
          navigate('/login');
        }
        return;
      }
      await user.reload();
      if (isMounted) {
        if (user.emailVerified) {
          console.log('User email verified:', user.uid);
          setLoading(false);
          navigate('/subscription');
        } else {
          console.log('User email not verified:', user.uid);
          setLoading(false);
          if (!error) {
            setError('Please check your email and verify your account.');
            toast.info('Please check your email and verify your account.');
          }
        }
      }
    };

    checkVerification();
    const interval = setInterval(checkVerification, 5000);
    const timeout = setTimeout(() => {
      if (isMounted && !auth.currentUser?.emailVerified) {
        setError('Verification timed out. Please try registering again.');
        toast.error('Verification timed out. Please try registering again.');
        navigate('/register');
      }
    }, 10 * 60 * 1000);

    return () => {
      isMounted = false;
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [navigate, error]);

  const resendVerification = async () => {
    try {
      await sendEmailVerification(auth.currentUser);
      console.log('Verification email resent to:', auth.currentUser.email);
      setError('Verification email resent. Please check your inbox.');
      toast.success('Verification email resent. Please check your inbox.');
    } catch (err) {
      console.error('Error resending verification email:', err);
      setError('Failed to resend verification email. Please try again.');
      toast.error('Failed to resend verification email.');
    }
  };

  const handleCancel = async () => {
    try {
      await signOut(auth);
      console.log('User signed out, redirecting to register');
      navigate('/register');
    } catch (err) {
      console.error('Error signing out:', err);
      setError('Failed to sign out: ' + err.message);
      toast.error('Failed to sign out: ' + err.message);
    }
  };

  if (loading) {
    return (
      <div className="verify-email-page">
        <div className="verify-email-container">
          <img src={logo} alt="Customs Pro AI Logo" className="verify-logo" />
          <ClipLoader color="#007bff" size={50} />
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="verify-email-page">
      <div className="verify-email-container">
        <img src={logo} alt="Customs Pro AI Logo" className="verify-logo" />
        <h2>Verify Your Email</h2>
        {error && <p className="verify-error">{error}</p>}
        <p>Check your email for a verification link.</p>
        <button onClick={resendVerification} className="verify-btn">Resend Verification Email</button>
        <button onClick={handleCancel} className="cancel-btn">Cancel</button>
      </div>
    </div>
  );
};

export default VerifyEmail;